<template>
  <div class="ma-4">
    <SkeletonLoaderTitleUpdate v-show="showSkeleton" />
    <div class="text-h4 mb-2" v-show="!showSkeleton">Atualizar Operador - {{ usuario }}</div>

    <div v-if="canRender">
      <CadastroOperador edicao="true" :_id="_id" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import SkeletonLoaderTitleUpdate from '@/componentes/SkeletonLoaderTitleUpdate'

import operadoresStore from '../_store'

import CadastroOperador from './CadastroOperador'

export default {
  name: 'AtualizarRamais',
  props: {
    _id: String,
  },
  components: { CadastroOperador, SkeletonLoaderTitleUpdate },
  data: () => ({
    usuario: '',
    showSkeleton: false,
    canRender: false,
  }),
  computed: {
    ...mapGetters('atualizarOperadorModuleCallCenterStore', ['getOperador']),
  },

  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'atualizarOperadorModuleCallCenterStore', operadoresStore)
    await this.listarOperadorEspecifico(this._id)
    this.usuario = this.getOperador.usuario

    this.showSkeleton = false
    this.canRender = true
  },

  methods: {
    ...mapActions('atualizarOperadorModuleCallCenterStore', ['listarOperadorEspecifico']),
  },
}
</script>
